import React from 'react'

import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon'

export const ReceiptFilled = Styled(
	createSvgIcon(
		<svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9.21807 0.5H3.5431C0.705618 0.5 0 1.25816 0 4.28331V12.7357C0 14.7325 1.09596 15.2054 2.42462 13.7791L2.43213 13.7716C3.04767 13.1185 3.98599 13.1711 4.51895 13.8842L5.27712 14.8976C5.88515 15.7008 6.86851 15.7008 7.47654 14.8976L8.2347 13.8842C8.77518 13.1636 9.7135 13.111 10.329 13.7716C11.6652 15.1979 12.7537 14.7249 12.7537 12.7282V4.28331C12.7612 1.25816 12.0555 0.5 9.21807 0.5ZM8.63255 7.8189H4.12861C3.82084 7.8189 3.56562 7.56368 3.56562 7.25591C3.56562 6.94814 3.82084 6.69292 4.12861 6.69292H8.63255C8.94032 6.69292 9.19555 6.94814 9.19555 7.25591C9.19555 7.56368 8.94032 7.8189 8.63255 7.8189ZM9.38321 4.81628H3.37796C3.07019 4.81628 2.81496 4.56105 2.81496 4.25328C2.81496 3.94551 3.07019 3.69029 3.37796 3.69029H9.38321C9.69098 3.69029 9.9462 3.94551 9.9462 4.25328C9.9462 4.56105 9.69098 4.81628 9.38321 4.81628Z"
				fill="currentColor"
			/>
		</svg>,
		'ReceiptFilled'
	)
)

export default ReceiptFilled
